import classNames from 'classnames'

import Image from '../ui/Image/Image'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { getImageUrl, isArabic } from '../../utils'
import Markdown from '../Markdown/Markdown'

import styles from './CompanyRegistration.module.scss'
import Call from '../../assets/images/call.svg'

const CompanyRegistration = ({ data }) => {
  const { language } = useLanguage()
  return (
    <>
      <div
        className={classNames(
          styles['top-container'],
          'w-full flex justify-center bg-white md:hidden'
        )}
      >
        <Image
          src={getImageUrl(data?.image)}
          alt={data?.image?.alternativeText}
        />
      </div>
      <div className={classNames(styles['container'])}>
        <div className="w-full flex justify-between items-start">
          <div className={classNames(styles['section-title'])}>
            {data?.title}
          </div>
          <div
            className={classNames(
              styles['top-container'],
              'hidden md:flex items-start bg-white gap-1',
              { [styles.arabicTopContainer]: isArabic(language.code) }
            )}
          >
            <Image
              src={getImageUrl(data?.image)}
              alt={data?.image?.alternativeText}
            />
          </div>
        </div>

        <div
          className={classNames(
            styles['grid-container'],
            'grid grid-cols-1 md:grid-cols-2'
          )}
        >
          {data?.subsection?.map((section) => {
            return (
              <div key={'subsection' + section?.id}>
                <div className={classNames(styles['grid-title'])}>
                  {section?.question}
                </div>
                <Markdown
                  content={section?.answer}
                  className={classNames(styles['grid-description'])}
                />
              </div>
            )
          })}
        </div>

        {/* <div
          className={classNames(
            styles['bottom-flex-container'],
            'w-full flex justify-end items-center'
          )}
        >
          <div
            className={classNames(styles['bottom-container'], {
              [styles.arabicBottomContainer]: isArabic(language.code),
            })}
          >
            <div className={classNames(styles['phone-details'])}>
              {data?.phoneTitle} {data?.phoneNumber}
            </div>
            <Image
              src={Call}
              alt={data?.phoneTitle}
              className={classNames(styles['call-icon'])}
            />
          </div>
        </div> */}
      </div>
    </>
  )
}

export default CompanyRegistration
